//*************************************************************************************
//* Session specific code
//*
//* 6/13/18 Kraus    [COM-136]: Created
//*************************************************************************************

app.Prospective = (function () {
    var gridId = "";
    var myProspective = {
        Index: function (gridId) {
            app.Prospective.Init(gridId);
        },
        Init: function (grididname) {
            gridId = grididname;
            $(document).on('change', "[data-role='response']",
                function () {
                    if ($("option:selected", this).data("unique-id") == "prospective-member-response-accepted-committee") {
                        $('[data-role="assigned-seat"]').show(500);
                    } else {
                        $('[data-role="assigned-seat"]').hide();
                    }
                    if ($("option:selected", this).data("unique-id") == "prospective-member-response-accepted-ballot") {
                        $('[data-role="assigned-ballot"]').show(500);
                    } else {
                        $('[data-role="assigned-ballot"]').hide();
                    }
                });

            $(document).on('change', "[data-role='election-selection']", function () {
                app.Prospective.ToggleProspectiveMemberBallotSeatSelection(this);
            });
            $(document).on('click', "[data-role='update-prospective-members']",
                function () {
                    app.Prospective.UpdateProspectiveMember(this, $(this).data('post-url'));
                });
            $(document).on('click', "[data-role='add-prospective-members']",
                function (e) {
                    app.Prospective.EditProspectiveMemberDetails(e);
                });
            app.Prospective.InitProspectiveMemberHistory();
            $(document).on('click', "[data-role='remove-prospective-members']",
                function () {
                    app.Prospective.RemoveProspectiveMember(this, $(this).data('post-url'));
                });
            app.Committee.InitAutoDateUpdate();
            app.Committee.InitSeatMemberFlags();
        },
        ToggleProspectiveMemberBallotSeatSelection: function (ddl) {
            if ($("option:selected", ddl).data("is-seat-ballot") == "1") {
                //seat selection! Update the other dropdown then show it
                var id = $("option:selected", ddl).data("election-id");
                $('[data-role="election-seat-selection"]').find('option').hide();
                $('[data-role="election-seat-selection"]').find('option[data-election-id=' + id + ']').show();
                $('[data-role="election-seat-selection"]').closest('div').show();
            } else {
                //show all options of other list and hide it.
                $('[data-role="election-seat-selection"]').find('option').hide();
                $('[data-role="election-seat-selection').closest('div').hide();
            }
        },
        EditProspectiveMemberDetails: function (e) {
            e.preventDefault();

            //show popup and loading first
            $('[data-role="edit-prospective-member-wrapper"]').html('');
            $('[data-role="edit-prospective-member-wrapper"]').addClass('popup-loading');
            $('#editProspectiveMemberModal').foundation('open');

            var ProspectiveMemberId = $(e.currentTarget).closest("tr").find('td:hidden').first().text();

            if (ProspectiveMemberId === "") {
                ProspectiveMemberId = "0";
            }
            var button = $(e.currentTarget);
            $.ajax({
                type: 'POST',
                dataType: 'html',
                url: $("#" + gridId).data("post-url"),
                data: JSON.stringify({
                    'Id': $(button).data('id'),
                    'CommitteeId': $(button).data('committee-id')
                }),
                contentType: "application/json; charset=utf-8",
                success: function (partialViewResult) {
                    $('[data-role="edit-prospective-member-wrapper"]').html(partialViewResult);
                    $('[data-role="edit-prospective-member-wrapper"]').removeClass('popup-loading');
                    app.input.initDatePicker($('[data-role="edit-prospective-member-wrapper"]'));
                    app.Prospective.ToggleProspectiveMemberBallotSeatSelection($("[data-role='election-selection']"));
                    //change drop down to filtered option if exists
                    if ($('[data-role="prospective-dropdown-commitee-filter"]').length) {
                        $('[data-role="edit-prospective-committee-dropdown"]', '[data-role="edit-prospective-member-wrapper"]').val($('[data-role="prospective-dropdown-commitee-filter"]').val());
                    }
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    toastr.error('Error loading prospective member details.', 'Error');
                    console.log('Error: ' + jqXHR + ", textStatus: " + textStatus + ", errorThrown: " + errorThrown);
                    console.log(JSON.stringify(jqXHR));
                }
            });
        },
        UpdateProspectiveMember: function (button, url) {
            var form = $(button).closest('.reveal').find('form');
            $.validator.unobtrusive.parse(form);

            console.log(form.valid());
            if (form.valid()) {

                $.ajax({
                    url: url,
                    type: 'POST',
                    data: form.serialize() + "&netid=" + $(button).closest('form').find('[data-role="netid"]').val(),
                    async: false,
                    success: function (partialViewResult) {
                        toastr.success('Prospective Member was saved successfully!', 'Save Successful');
                        //getActivityLogResults();

                        //update the grid to reflect an changes
                        app.KendoGrids.GetResults(gridId);

                        //close the popup.
                        $('#editProspectiveMemberModal').foundation('close');
                    },
                    error: function (result) {
                        toastr.error('There was an error while saving the prospective member.', 'Error');
                    }
                });
            }
            else {
                //Give focus to the first error
                var firstError = $('#' + $('.field-validation-error', form).data('valmsg-for'));
                if (firstError.length) {
                    $('html, body').animate({
                        scrollTop: firstError.offset().top - 50
                    }, 500);
                }
            }
        },
        RemoveProspectiveMember: function (button, url) {
            if (confirm("Are you sure you want to delete this Prospective Member?")) {
                var memberId = $(button).closest('.reveal').find('form').find('[data-role="prospective-member-id"]').val();

                if (memberId === "") {
                    memberId = "0";
                }

                $.ajax({
                    type: 'POST',
                    url: url,
                    data: JSON.stringify({
                        'Id': memberId,
                        'controllerId': app.page.id
                    }),
                    contentType: "application/json; charset=utf-8",
                    success: function (partialViewResult) {
                        $('#editProspectiveMemberModal').foundation('close');
                        app.KendoGrids.GetResults(gridId);
                    },
                    error: function (jqXHR, textStatus, errorThrown) {
                        toastr.error('Error loading seat member details.', 'Error');
                        console.log('Error: ' + jqXHR + ", textStatus: " + textStatus + ", errorThrown: " + errorThrown);
                        console.log(JSON.stringify(jqXHR));
                    }
                });
            }
        },
        InitProspectiveMemberHistory: function () {
            $("#" + gridId).kendoGrid({
                filterable: {
                    extra: false,
                    operators: {
                        string: {
                            startswith: "Starts with",
                            eq: "Is equal to",
                            neq: "Is not equal to"
                        }
                    }
                },
                toolbar: ["excel"],
                excel: {
                    fileName: "ProspectiveMembers.xlsx"
                },
                columns: [{
                    field: "Id",
                    title: "Id",
                    hidden: true
                },
                {
                    field: "CommitteeName",
                    title: "Committee",
                    hidden: $("#" + gridId).data('show-committee') ? false : true
                },
                {
                    field: "CommitteeSeatType",
                    title: "Seat Type"
                },
                {
                    field: "FirstName",
                    title: "First Name",
                    template: "<a href='#=UserAddress#'>#=FirstName#</a>"
                },
                {
                    field: "LastName",
                    title: "Last Name",
                    template: "<a href='#=UserAddress#'>#=LastName#</a>"
                },
                {
                    field: "Title",
                    title: "Title",
                    hidden: true
                },
                {
                    field: "DepartmentName",
                    title: "Department Name",
                    hidden: true
                },
                {
                    field: "Division",
                    title: "Division",
                    hidden: true
                },
                {
                    field: "Department",
                    title: "Department",
                    hidden: true
                },
                {
                    field: "Subdepartment",
                    title: "Subdepartment",
                    hidden: true
                },
                {
                    field: "FacultyDivision",
                    title: "Faculty Division",
                    hidden: true
                },
                {
                    field: "ReasonToAdd",
                    title: "Reason Added"
                },
                {
                    field: "AddedDate",
                    title: "Date Added",
                    format: "{0:M/d/yyyy}"
                },
                {
                    field: "Notes",
                    title: "Notes"
                },
                {
                    field: "Response",
                    title: "Response"
                },
                {
                    field: "ResponseDate",
                    title: "Response Date",
                    format: "{0:M/d/yyyy}"
                },
                {
                    template: "<button type='button' data-committee-id='#=CommitteeId#' data-id='#=Id#' data-role='edit-prospective-member' class='button info remove-rounded-corners'>Edit</button>"
                }],
                noRecords: true,
                scrollable: false,
                width: 100,
                sortable: true,
                columnMenu: true,
                groupable: {
                    messages: {
                        empty: "Drop columns here to group by"
                    }
                },
                dataSource: {
                    schema: {
                        model: {
                            fields: {
                                AddedDate: { type: "date" },
                                ResponseDate: { type: "date" }
                            }
                        }
                    }
                }
            });
            app.KendoGrids.InitPersistentGrid(gridId, true);
            $("#" + gridId).on("click", "[data-role='edit-prospective-member']", function (e) { app.Prospective.EditProspectiveMemberDetails(e); });
        }
    };
    return myProspective;
}());